// extracted by mini-css-extract-plugin
module.exports = {"tags":"_3SXpw","activeTag":"_5+J3G"};